module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityId),
      expression: "cityId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cityId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onInput]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("市区町村を選択してください。")]), _vm._v(" "), _vm._l((_vm.cities), function(prefecture) {
    return _c('option', {
      domProps: {
        "value": prefecture.city_id
      }
    }, [_vm._v("\n    " + _vm._s(prefecture.city_name) + "\n  ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-570d00c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/SelectCity.vue
// module id = 459
// module chunks = 1